import { useState, useEffect, MutableRefObject } from 'react';

type UseIntersectionObserverOptionsType = IntersectionObserverInit & {
    freezeOnceVisible?: boolean;
};

const useIntersectionObserver = (
    elementRef: MutableRefObject<HTMLElement>,
    {
        threshold = 0,
        root = null,
        rootMargin = '0%',
        freezeOnceVisible = false
    }: UseIntersectionObserverOptionsType = {}
) => {
    const [isVisible, setState] = useState<boolean>(false);
    const frozen = isVisible && freezeOnceVisible;

    useEffect(() => {
        const node = elementRef?.current; // DOM Ref
        const hasIOSupport = !!window.IntersectionObserver;

        if (!hasIOSupport || frozen || !node) return;

        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(([entry]) => {
            setState(entry.isIntersecting);
        }, observerParams);

        observer.observe(node);

        return () => observer.disconnect();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementRef, threshold, root, rootMargin, frozen]);

    return isVisible;
};

export default useIntersectionObserver;
